/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';

export interface DeviceControllerFindByMacAddress$Params {
  macAddress: string;
}

export function deviceControllerFindByMacAddress(http: HttpClient, rootUrl: string, params: DeviceControllerFindByMacAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerFindByMacAddress.PATH, 'get');
  if (params) {
    rb.path('macAddress', params.macAddress, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceDto>;
    })
  );
}

deviceControllerFindByMacAddress.PATH = '/api/device/mac/{macAddress}';
